import { validatePasswordPair } from '../../_shared/domain/password.validation';
import type { OnboardingDraft } from './onboarding.model';

export { MIN_PASSWORD_LENGTH } from '../../_shared/domain/password.validation';

/** Field-level validation errors, keyed by draft field name. Empty = valid. */
export type ValidationErrors = Partial<Record<keyof OnboardingDraft, string>>;

/**
 * Pure business validation for the onboarding draft. Delegates to the
 * auth-wide password-pair rules (`_shared`): the minimum-length rule reports
 * before the mismatch, so a too-short password never also flags the
 * confirmation.
 */
export function validateDraft(draft: OnboardingDraft): ValidationErrors {
  return validatePasswordPair(draft);
}
